import Reflux from 'reflux'

export default Reflux.createActions([
  'loadAll',
  'saveLocation', // (location)
  'deleteLocation' // (tagId)
])
